import PropTypes from 'prop-types';
import React from 'react';

import LabelAsHTML from './LabelAsHTML';
import { setClassNames } from '../utils/utility';

const PricingSummaryFinalPrice = ({
	price,
	buttonResetClasses,
	viewPriceDetail,
	finalLabelSize,
	finalPrice,
	finalPriceSize
}) => {
	if (price && price.isFinalPrice && finalPrice && viewPriceDetail) {
		return (
			<button
				className={`${buttonResetClasses} w-100`}
				onClick={viewPriceDetail}
			>
				<span
					className={setClassNames(
						'text-muted',
						'd-block',
						finalLabelSize
					)}
				>
					<LabelAsHTML label={price.label} />{' '}
				</span>
				<strong
					className={setClassNames(
						'line-height-reset',
						finalPriceSize
					)}
				>
					{finalPrice}
				</strong>
			</button>
		);
	}
	return null;
};

PricingSummaryFinalPrice.propTypes = {
	price: PropTypes.shape({
		_type: PropTypes.string.isRequired,
		formatted: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		value: PropTypes.number.isRequired
	}).isRequired,
	buttonResetClasses: PropTypes.string,
	viewPriceDetail: PropTypes.func.isRequired,
	finalLabelSize: PropTypes.string,
	finalPrice: PropTypes.string.isRequired,
	finalPriceSize: PropTypes.string
};

PricingSummaryFinalPrice.defaultProps = {
	buttonResetClasses: '',
	finalLabelSize: '',
	finalPriceSize: ''
};

export default PricingSummaryFinalPrice;



// WEBPACK FOOTER //
// ./src/components/PricingSummaryFinalPrice.jsx